import { isEmpty } from "lodash";
import { InstanceApi_getDetail } from "@next-api-sdk/cmdb-sdk";
const menuTitleCache = new Map();
export async function fetchMenuTitle(menuData) {
  if (menuData.title || isEmpty(menuData.titleDataSource)) {
    return menuData.title;
  }
  const cacheKey = JSON.stringify(menuData.titleDataSource);
  const cachedTitle = menuTitleCache.get(cacheKey);
  if (cachedTitle !== undefined) {
    return cachedTitle;
  }
  const {
    objectId,
    instanceId,
    attributeId
  } = menuData.titleDataSource;
  const attr = attributeId !== null && attributeId !== void 0 ? attributeId : "name";
  const instanceData = await InstanceApi_getDetail(objectId, instanceId, {
    fields: attr
  });
  let title;
  if (attributeId === "#showKey" && Array.isArray(instanceData[attr])) {
    const [primary, ...rest] = instanceData[attr];
    title = rest.length > 0 ? `${primary}(${rest.join(",")})` : String(primary);
  } else {
    title = String(instanceData[attr]);
  }
  menuTitleCache.set(cacheKey, title);
  return title;
}
//# sourceMappingURL=fetchMenuTitle.js.map